export enum EPetitionStatus {
	zverejnena = 'ZVEREJNENA',
	vytvorena = 'VYTVORENA',
	rozpracovana = 'ROZPRACOVANA',
	uzavrena = 'UZAVRENA',
	podana = 'PODANA',
	zamitnuta = 'ZAMITNUTA',
}
